var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnselectedReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16667 0.5V13.8333H15.5V15.5H0.5V0.5H2.16667ZM14.9108 3.24417L16.0892 4.4225L11.3333 9.17833L8.83333 6.67917L5.25583 10.2558L4.0775 9.0775L8.83333 4.32167L11.3333 6.82083L14.9108 3.24417Z",
    fill: "#9AA2B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnselectedReports);
export default __webpack_public_path__ + "static/media/unselected_reports.34f8846c08e0f55aa6b06596eef61628.svg";
export { ForwardRef as ReactComponent };